<kit-bs-form-field [kitModel]="nameField"></kit-bs-form-field>
<kit-bs-checkbox [kitCheckbox]="isActiveCheckbox"></kit-bs-checkbox>
<kit-bs-button [kitModel]="confirmAction"></kit-bs-button>
